var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Tooltip',{attrs:{"label":_vm.tooltipContent || _vm.$t('inspections.fill-out-form'),"position":"is-top"}},[_c('router-link',{attrs:{"to":_vm.route}},[_c('Button',{staticClass:"checklist-index-page__action-button",attrs:{"type":"is-light","tag":"button","icon-right":"play","icon-pack":"far"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }